export default __webpack_public_path__ + "static/media/data-science.43a62dad.svg";